module.exports = __webpack_public_path__ + "static/img/1.d6a57be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/毕业照/1.jpg
// module id = w6v1
// module chunks = 0